module.exports = __webpack_public_path__ + "assets/img/4.72212e22.png";